<template>
  <v-sheet width="300px" height="100px">
    <canvas :id="guid" width="300" height="100" />
    <v-dialog activator="parent" width="800">
      <v-card subtitle="ИНФОРМАЦИЯ">
        <template v-slot:text>
          <v-table fixed-header style="overflow-x: auto">
            <thead>
            <tr>
              <th class="text-left font-weight-bold">
                Неделя
              </th>
              <th class="text-left font-weight-bold">
                <p>Инциденты</p>
                <p>Ложные сработки</p>
              </th>
              <th class="text-left font-weight-bold">
                <p>Заявки на Отчёт, Испытания,<br>ТО, Плановые работы</p>
              </th>
              <th class="text-left font-weight-bold">
                <p>СМР/ПНР</p>
                <p>Доп. и прочие работы</p>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="el in report_data" :key="el">
              <td class="text-left font-weight-bold">
                {{ el.week }}
              </td>
              <td>{{ el.group_1.toFixed(0) }}</td>
              <td>{{ el.group_2.toFixed(0) }}</td>
              <td>{{ el.group_3.toFixed(0) }}</td>
            </tr>
            </tbody>
          </v-table>
        </template>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import { Chart } from "chart.js"

export default {
  name: 'Report__Appeals',
  props: ['report_data', 'guid', 'name'],
  mounted() {
    this.canvas = document.getElementById(this.guid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      graph: null,
      canvas: null,
      weeks: null,

      group_1: null,
      group_2: null,
      group_3: null
    }
  },
  methods: {
    make_chart: function() {
      this.update_data()
      if (this.canvas) {
        this.graph = new Chart(this.canvas, {
          type: 'line',
          data: {
            labels: this.weeks,
            datasets: [{
              label: "Инциденты",
              data: this.group_1,
              borderColor: '#d5a735',
              backgroundColor: '#d5a735',
              pointStyle: 'circle',
              pointRadius: 0,
              pointHoverRadius: 0,
            }, {
              label: "Другие",
              data: this.group_2,
              borderColor: '#e88282',
              backgroundColor: '#e88282',
              pointStyle: 'circle',
              pointRadius: 0,
              pointHoverRadius: 0,
            },{
              label: "Другие",
              data: this.group_3,
              borderColor: '#82e8d0',
              backgroundColor: '#82e8d0',
              pointStyle: 'circle',
              pointRadius: 0,
              pointHoverRadius: 0,
            }]
          },
          options: {
            plugins: {
              legend: {
                display: false
              }
            }
          }
        })
      }
    },
    update_data: function () {
      this.weeks =      this.report_data.map(el => el.week)
      this.group_1 = this.report_data.map(el => el.group_1)
      this.group_2 = this.report_data.map(el => el.group_2)
      this.group_3 = this.report_data.map(el => el.group_3)
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    }
  }
}
</script>

<style scoped>

</style>
